import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthService from "./services/AuthService";

const container = document.getElementById("root");
const root = createRoot(container);

const initializeApplication = async () => {
  try {
    await AuthService.initialize();
  } catch (error) {
    console.error("Unable to initialize authentication.", error);
    AuthService.logoutLocal();
  }
};

function Root() {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    initializeApplication().finally(() => {
      if (isMounted) {
        setIsAuthReady(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isAuthReady) {
    return (
      <div className="app-loading" role="status" aria-live="polite">
        Checking your session...
      </div>
    );
  }

  return <App />;
}

root.render(<Root />);
reportWebVitals();
